<template>
  <div class="footer">
    <div class="layout">
      <div class="infos">
        <!-- <p><span>地址</span>广东省珠海市高新区港湾大道港湾一号港11栋</p> -->
        <p><span>商务合作</span>sales@4dage.com</p>
        <p><span>媒体采访</span>pr@4dage.com</p>
        <!-- <p><span>地址</span>广东省珠海市高新区港湾大道港湾一号港11栋</p> -->
        <p><span>联系电话</span>400-6698-025</p>
      </div>
      <div class="relevant">
        <div>
          <a href="http://www.4dkankan.com" target="_blank">四维看看</a>
          <a href="http://www.4dmodel.com/" target="_blank">四维模库</a>
          <a href="http://www.cgaii.com" target="_blank">中德人工智能研究院</a>
        </div>
        <p>Copyright © 2017 4DAGE Co, Ltd. All rights reserved. </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
  .footer {
    padding-top: 40px;
    padding-bottom: 50px;
    background-color: #292929 !important;
  }

  .footer .layout {
    margin: 0 auto;
    max-width: 1440px;
    padding-left: 20px;
    padding-right: 20px;
    overflow: hidden;
  }

  .infos {
    float: left;
  }

  .infos > p {
    font-size: 14px;
    color: #fff;
    line-height: 1.8;
  }

  .infos > p > span {
    display: inline-block;
    width: 90px;
    text-align: right;
  }

  .infos > p > span::after {
    content: ':';
    /* display: inline-block; */
    float: right;
    padding: 0 15px;
  }

  .relevant {
    float: right;
  }

  .relevant > div {
    margin-bottom: 33px;
  }

  .relevant > div > a {
    color: #00b4ed;
    font-size: 14px;
    text-decoration: underline;
    display: inline-block;
    line-height: 25px;
  }

  .relevant > div > a:nth-child(2) {
    margin: 0 42px;
  }

  .relevant > p {
    font-size: 14px;
    color: #ffffff;
  }

  @media screen and (max-width: 1050px) {
    .footer {
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .infos > p {
      text-align: center;
      margin-bottom: 10px;
    }

    .infos > p > span {
      display: block;
      color: #00b4ed;
      width: auto;
      text-align: center;
    }

    .infos > p > span::after {
      display: none;
    }
    .infos {
      float: none;
    }

    .relevant {
      float: none;
      margin-top: 20px;
    }

    .relevant > div {
      text-align: center;
      margin-bottom: 15px;
    }

    .relevant > div > a {
      margin: 0 10px;
    }

    .relevant > div > a:nth-child(2) {
      margin-left: 0;
      margin-right: 0;
      margin-top: 15px;
    }

    .relevant > p {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/footer.vue